import { ServiceHandler } from '../../utils';
import type { CveProfile } from '../../components/ask-moo/types';

/**
 * Fetch the rich CVE profile by CVE id.
 * 200 → CveProfile | 404 unknown cveId | 403 unauthorized.
 */
export const getCveProfile = ServiceHandler<unknown, CveProfile>({
  url: '/api/risk/v1/cves/:cveId',
});
